import { getDefaultCurrency } from '../config/currency';

export function useCurrency() {
  return getDefaultCurrency();
}
